import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import ThreeItems from './ThreeItems';
import FourItems from './FourItems';
import FiveItems from './FiveItems';
import SixItems from './SixItems';
import SevenItems from './SevenItems';
import EightItems from './EightItems';
import { styles } from './styles/videoCollectionStyles';
import VideoCollectionsService from '../VideoCollectionsService';

const containers = [null, null, null, ThreeItems, FourItems, FiveItems, SixItems, SevenItems, EightItems];

class VideoCollection extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			collection: props.collection,
		};
	}

	render() {
		const collection = this.state.collection;
		const ContainerTag = containers[collection.posts.length] || ThreeItems;
        let utmObj = VideoCollectionsService.setCollectionUTM(collection, this.props.index);

		return (
			<div id={this.props.id}>
				<input type="hidden" value={collection.posts.length} className={'collection-size_vc'}/>
				<div className={css(styles.header) + ' header_vc'}>
					<h3 className={css(styles.title) + ' title_vc'}>{collection.collectionTitle}</h3>
					<a className={css(styles.moreLink, styles.moreLinkHeader) + ' more-link_vc'} href={collection.moreLink}>{collection.moreLabel}</a>
				</div>
				<ContainerTag posts={collection.posts} containerStyle={styles.container} utmObj={utmObj} />
				<div className={css(styles.footer) + ' footer_vc'}>
					<a className={css(styles.moreLink, styles.moreLinkFooter) + ' more-link_vc'} href={collection.moreLink}>{collection.moreLabel}</a>
				</div>
			</div>
		);
	}
}

export default VideoCollection;
